<template>
  <div class="notice-highlight-section" :class="{ 'notice-highlight-section--is-pc': isPc }">
    <div class="notice-highlight-section__modal">
      <p class="notice-highlight-section__new">NEW</p>
      <h3 class="notice-highlight-section__title">
        {{ $tc('RaceVideoPage.highlights.notice.title') }}
      </h3>
      <p class="notice-highlight-section__message">
        {{ $tc('RaceVideoPage.highlights.notice.message') }}
      </p>
      <button
        class="notice-highlight-section__button notice-highlight-section__button--light--secondary"
        @click="handleOkClicked"
      >
        OK
      </button>
    </div>
    <div class="notice-highlight-section__bg-top"></div>
    <div class="notice-highlight-section__bg-right"></div>
    <div class="notice-highlight-section__bg-bottom"></div>
    <div class="notice-highlight-section__bg-left"></div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from '@vue/composition-api'
import DeviceInfo from '@/util/DeviceInfo'

export default defineComponent({
  name: 'NoticeHighlightSection',
  setup(_, { emit }) {
    const isPc = DeviceInfo.isForPC()

    const handleOkClicked = () => {
      emit('onClickOk')
    }

    return {
      isPc,
      handleOkClicked,
    }
  },
})
</script>

<style scoped lang="scss">
.notice-highlight-section {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 100;
  text-align: center;

  &__new {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 56px;
    height: 24px;
    font-size: 12px;
    font-weight: bold;
    color: $black;
    letter-spacing: 0.04em;
    background-color: $green-light;
    border-radius: 80px;
  }

  &__modal {
    position: absolute;
    bottom: 123px;
    left: 50%;
    z-index: 2;
    width: calc(100% - 32px);
    padding: 20px 16px;
    background-color: rgba(#fff, 0.9);
    border-radius: 12px;
    transform: translateX(-50%);

    &::after {
      position: absolute;
      bottom: -10px;
      right: 12px;
      width: 0;
      height: 0;
      content: '';
      border-style: solid;
      border-right: 10px solid transparent;
      border-left: 10px solid transparent;
      border-top: 10px solid rgba(#fff, 0.9);
      border-bottom: 0;
    }
  }

  &__title {
    margin-top: 11px;
    font-size: 16px;
    font-weight: 500;
    color: $black;
  }

  &__message {
    margin-top: 20px;
    font-size: 12px;
    font-weight: 500;
    color: $gray75;
    letter-spacing: 0.02em;
    white-space: pre-wrap;
    text-align: left;
  }

  &__button {
    margin-top: 20px;
    @include button();

    width: 100%;
    height: 40px;
  }

  &__bg-top {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: calc(100% - var(--safe-area-inset-bottom) - 102px);
    background-color: $black70;
  }

  &__bg-right {
    position: absolute;
    bottom: calc(var(--safe-area-inset-bottom) + 42px);
    right: 0;
    width: 8px;
    height: 60px;
    background-color: $black70;

    &::before {
      position: absolute;
      top: 0;
      left: -30px;
      width: 30px;
      height: 30px;
      content: '';
      background-image: url('@/assets/img/RaceVideoPage/notice/bg_corner_right_top.svg');
      background-repeat: no-repeat;
      background-position: center;
      background-size: contain;
    }

    &::after {
      position: absolute;
      bottom: 0;
      left: -30px;
      width: 30px;
      height: 30px;
      content: '';
      background-image: url('@/assets/img/RaceVideoPage/notice/bg_corner_right_bottom.svg');
      background-repeat: no-repeat;
      background-position: center;
      background-size: contain;
    }
  }

  &__bg-bottom {
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    height: calc(var(--safe-area-inset-bottom) + 42px);
    background-color: $black70;
  }

  &__bg-left {
    position: absolute;
    bottom: calc(var(--safe-area-inset-bottom) + 42px);
    left: 0;
    width: calc(100% - 68px);
    height: 60px;
    background-color: $black70;

    &::before {
      position: absolute;
      top: 0;
      right: -30px;
      width: 30px;
      height: 30px;
      content: '';
      background-image: url('@/assets/img/RaceVideoPage/notice/bg_corner_left_top.svg');
      background-repeat: no-repeat;
      background-position: center;
      background-size: contain;
    }

    &::after {
      position: absolute;
      bottom: 0;
      right: -30px;
      width: 30px;
      height: 30px;
      content: '';
      background-image: url('@/assets/img/RaceVideoPage/notice/bg_corner_left_bottom.svg');
      background-repeat: no-repeat;
      background-position: center;
      background-size: contain;
    }
  }

  &--is-pc {
    .notice-highlight-section__modal {
      bottom: 311px;
      left: auto;
      right: 16px;
      width: 342px;
      transform: translateX(0);
    }

    .notice-highlight-section__bg-top {
      height: calc(100% - 220px - 12px - 52px - 4px);
    }

    .notice-highlight-section__bg-right {
      bottom: 228px;
    }

    .notice-highlight-section__bg-bottom {
      height: 228px;
    }

    .notice-highlight-section__bg-left {
      bottom: 228px;
    }
  }
}
</style>
